import { AlertCircle, RotateCcw } from "lucide-react";

/**
 * Reusable Empty / Error / Success state views for tables and lists.
 * Matches the Emad design system (cream/teal palette, Neo Sans Arabic).
 */

export function EmptyState({ icon: Icon, title, description, action, testid }) {
  return (
    <div
      className="p-12 sm:p-16 rounded-2xl bg-white border border-cream-200 text-center"
      data-testid={testid || "empty-state"}
    >
      {Icon && <Icon className="h-12 w-12 text-slate-400 mx-auto mb-4" strokeWidth={1.5} />}
      <h3 className="text-lg font-heading font-bold text-slate-900">{title}</h3>
      {description && (
        <p className="text-slate-600 mt-2 max-w-md mx-auto leading-relaxed">{description}</p>
      )}
      {action && <div className="mt-6 flex items-center justify-center">{action}</div>}
    </div>
  );
}

export function ErrorState({ message, onRetry, testid }) {
  return (
    <div
      role="alert"
      className="p-12 rounded-2xl bg-white border border-red-100 text-center"
      data-testid={testid || "error-state"}
    >
      <AlertCircle className="h-10 w-10 text-red-500 mx-auto mb-4" strokeWidth={1.75} />
      <h3 className="text-lg font-heading font-bold text-slate-900">تعذّر تحميل البيانات</h3>
      <p className="text-slate-600 mt-2 max-w-md mx-auto leading-relaxed">
        {message || "حدث خطأ غير متوقع أثناء الاتصال بالخادم."}
      </p>
      {onRetry && (
        <button
          onClick={onRetry}
          className="mt-6 inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-teal-700 text-white font-semibold hover:bg-teal-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-teal-500/50 transition-colors"
          data-testid={`${testid || "error-state"}-retry`}
        >
          <RotateCcw className="h-4 w-4" /> إعادة المحاولة
        </button>
      )}
    </div>
  );
}
